import { Box, Typography, Container, IconButton, Paper } from "@mui/material";
import { useRef, useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import About from "../About/About";
import EmailSubscribe from "../EmailSubscribe/EmailSubscribe";
import HomeBanner from "../../Components/HomeBanner/HomeBanner";
import Category from "../Category/Category";
import { getData } from "../../Webservice/Webservice";
import Layout1 from "../../Components/HomeLayouts/Layout1";
import Layout2 from "../../Components/HomeLayouts/Layout2";
import Layout3 from "../../Components/HomeLayouts/Layout3";
import Layout4 from "../../Components/HomeLayouts/Layout4";
import Layout5 from "../../Components/HomeLayouts/Layout5";
import Tabsection from "../../Components/Tabsection/Tabsection";
import LayoutSkeleton from "../../Components/Skeleton/LayoutSkeleton";

const rubikfont = {
  fontFamily: "Rubik, san-serif"
};
function Home() {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [layouts, setLayouts] = useState([]);
  const [loading, setLoading] = useState(true);

  const checkScrollButtons = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScrollButtons();
    window.addEventListener("resize", checkScrollButtons);
    return () => window.removeEventListener("resize", checkScrollButtons);
  }, []);

  // Auto scroll functionality
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const autoScroll = setInterval(() => {
      const { scrollLeft, scrollWidth, clientWidth } = container;

      if (scrollLeft >= scrollWidth - clientWidth - 10) {
        container.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        container.scrollBy({ left: 300, behavior: "smooth" });
      }

      setTimeout(checkScrollButtons, 500);
    }, 3000);

    return () => clearInterval(autoScroll);
  }, []);

  useEffect(() => {
    const fetchLayouts = async () => {
      try {
        const response = await getData("homepage/layout/list?page=1&limit=5");
        if (response && response.layout) {
          setLayouts(response.layout);
        }
      } catch (error) {
        console.error("Error fetching layouts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLayouts();
  }, []);

  return (
    <Box sx={{ width: "100%", minHeight: "100vh" }}>

      <HomeBanner />

      {/*Layout sections */}
      {loading ? (
        Array.from(new Array(5)).map((_, index) => (
          <LayoutSkeleton key={index} />
        ))
      ) : (
        layouts.map((layoutData) => {
          const layoutName = layoutData.layoutId?.name;
          const LayoutComponent = {
            layout1: Layout1,
            layout2: Layout2,
            layout3: Layout3,
            layout4: Layout4,
            layout5: Layout5,
          }[layoutName];

          return LayoutComponent ? (
            <LayoutComponent key={layoutData._id} data={layoutData} />
          ) : null;
        })
      )}

      <Category />

      {/* Offer banner Container */}
      <Box >
        <Box >
          <Box
            sx={{
              position: "relative",
              height: { xs: "300px", md: "500px" },
              overflow: "hidden",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=1200"
              alt="Featured Offer"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to right, rgba(0,0,0,0.7), transparent)",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-start" },
                p: { xs: 2.5, sm: 4, md: 6 }, // responsive padding
              }}
            >
              <Box
                sx={{
                  maxWidth: { xs: "90%", sm: "70%", md: "50%" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: "26px", sm: "34px", md: "50px" },
                    fontWeight: 700,
                    mb: { xs: 1, sm: 1.5, md: 2 },
                    lineHeight: 1.1,
                    ...rubikfont,
                  }}
                >
                  MEGA SALE
                </Typography>

                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: "14px", sm: "18px", md: "24px" },
                    mb: { xs: 2, sm: 2.5, md: 3 },
                    ...rubikfont,
                  }}
                >
                  Up to 70% OFF on Selected Items
                </Typography>

                <Box
                  sx={{
                    bgcolor: "white",
                    color: "#222",
                    px: { xs: 3, sm: 3.5, md: 4 },
                    py: { xs: 1, sm: 1.2, md: 1.5 },
                    display: "inline-block",
                    borderRadius: 999,
                    fontWeight: 600,
                    fontSize: { xs: "13px", sm: "14px", md: "15px" },
                    cursor: "pointer",
                    ...rubikfont,
                  }}
                >
                  Shop Now
                </Box>
              </Box>
            </Box>

          </Box>
        </Box>
      </Box>

      <Tabsection />



      {/* <About /> */}

      <EmailSubscribe />

      <Footer />

    </Box>
  );
}

export default Home;